<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <!-- <Wxts :wxtsList="wxtsList" /> -->
    </div>


    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
// import Wxts from '../../../components/Wxts.vue';
import detailMixin from "../../mixin/detail";

export default {
  // components: { Wxts },
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'alert',
      breadcrumb: [
        { name: "系统设置" },
        { name: "提醒人配置" },
      ],
      wxtsList: [],
      formCtrl: [
        {
          label: "车辆异常提醒人",
          keyName: "abnormal",
          err: "请填写车辆异常提醒人",
          type: "select",
          multiple: true,
          options: [],
        },
        {
          label: "催款提醒人",
          keyName: "dunning",
          err: "请填写催款提醒人",
          type: "select",
          multiple: true,
          options: [],
        },
        {
          label: "保险到期提醒人",
          keyName: "insurance",
          err: "请填写保险到期提醒人",
          type: "select",
          multiple: true,
          options: [],
        },
        {
          label: "证件到期提醒人",
          keyName: "document_maturity",
          err: "请填写证件到期提醒人",
          type: "select",
          multiple: true,
          options: [],
        },
      ],
    };
  },
  methods: {
    async getOptions2() {
      this.loading = true
      let url = `${this.baseUrl}/userlist`;
      const params = {
        userid: this.user.id,
      }
      const { data: { msg, data } } = await this.POST(url, params)
      // console.log(msg, data)
      this.loading = false
      if (msg === 'success') {
        const arr = data.map(val => {
          return {
            label: val.nickname,
            value: val.id,
          }
        })
        // console.log(arr)
        this.formCtrl.map(v => {
          v.options = arr
        })
        this.getData()
      } else {
        this.$message({
          type: 'error',
          message: '暂无数据，请先设置人员信息！',
        });
      }
    },
    getOptions() {
      this.loading = true
      let url = `${this.baseUrl}/userlist`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (data && Array.isArray(data)) {
          if (msg === 'success') {
            const arr = data.map(val => {
              return {
                label: val.nickname,
                value: val.id + '',
              }
            })
            // console.log(arr)
            this.formCtrl.map(v => {
              v.options = arr
            })
          } else {
            this.$message({
              type: 'warrning',
              message: '暂无数据，请先设置人员信息！',
            });
          }
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.formCtrl.map(v => {
            const key = v.keyName
            const obj = data[key]
            // console.log(obj)
            if (Array.isArray(obj)) {
              this.form[key] = obj.map(v => v.id)
            } else if (obj.id) {
              this.form[key] = [obj.id]
            }
          })
          // console.log({ ...this.form });
          // console.log({ ...data });
          this.$forceUpdate()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        // this.$message({
        //   type: 'error',
        //   message: '获取数据失败，请稍后重试！'
        // });
      })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      const object = this.form
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const value = object[key];
          if (Array.isArray(value)) {
            params[key] = value.join(',')
          } else {
            params[key] = value;
          }
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions2()
    // this.getOptions()
    // this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .tips {
      margin: 10px auto 0;
    }

    .el-select {
      width: 230px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>
